<template>
  <div class="footer-bar">
    <div class="left">
      <p>版权所有：华南农业大学（粤ICP备05008874号）</p>
      <p>技术支持：广州世峰数字科技有限公司</p>
      <p><router-link to="/login">平台登录</router-link></p>
    </div>
    <div class="middle">
      <img src="@/assets/logo.png" class="logo" />
    </div>
    <div class="right">
      <img src="@/assets/qrcode.png" class="qrcode" />
      <img src="@/assets/qrcode.png" class="qrcode" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FooterBar'
  }
</script>

<style lang="scss" scoped>
.footer-bar {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  .left {
    text-align: right;
    width: 315px;
    p {
      line-height: 2em;
    }
    a {
      color: #ffffff;
    }
  }
  .middle {
    width: 570px;
    text-align: center;
    .logo {
      height: 50px;
      display: block;
      margin: 0 auto;
    }
  }
  .right {
    width: 315px;
    .qrcode {
      width: 92px;
      height: 92px;
      margin: 0 10px;
    }
  }
}
</style>
